<div class="kp-card relative mx-1 px-1 mb-0 f-initial">
  <ngx-spinner name="promote" [fullScreen]="false" type="timer"></ngx-spinner>

  <ng-container *ngIf="!payment">

    <app-login *ngIf="showLogin" [inline]="true" [show-name-input]="false" [autoFocus]="true" [heading]="''"
      (login)="openPaymentModal()" intro="برای پیشتاز شدن به شماره موبایل‌ت نیاز داریم"></app-login>

    <ng-container *ngIf="!showLogin">

      <h1 class="h3 text-center">اولین کسی باش که از آگهی‌ها خبردار می‌شه</h1>
      <div>
        با خرید بسته پیشتاز هر روز فرصت‌های شغلی جدید رو روی <i
          class="fas fa-mobile-alt fs-xxl ml-1 f-dark-blue yellow-bg"></i>گوشی دریافت کن.
        و <b>اگر بخوای</b> کارفرماهای مناسب هم باهات تماس خواهند گرفت.
      </div>
      <!-- <app-push-activator *ngIf="user?.Seeker?.PromoteUntilDays>0"></app-push-activator> -->

      <div>
        <button class="btn btn-link f-blue" (click)="useDiscount=true" *ngIf="!useDiscount">کد تخفیف داری؟</button>
        <ng-container *ngIf="useDiscount">
          <div *ngIf="!discount" class="d-flex justify-content-between">
            <input class="text-center p-1 ml-2" dir="ltr" type="text" #code placeholder="کد تخفیف"
              [(ngModel)]="discountCode" name="discountCode" [disabled]="discount?.Percentage==100"
              (change)="discount=undefined;invalidDiscount=false" />
            <input class="btn btn-secondary btn-sm px-4 w-initial" type="button" (click)="tryBestDiscount(code.value)"
              value="اعمال کد" />

          </div>
          <div class="kp-message kp-message-success mx-2" *ngIf="discount">
            {{discount.Percentage/100|percent}} درصد تخفیف
            <span>«{{discount.Title}}»</span> برای شما اعمال شد.
          </div>
          <div class="kp-message kp-message-error mx-1" *ngIf="invalidDiscount">
            کد تخفیف نامعتبر است.
            <div>
              <button class="btn btn-secondary btn-sm w-100"
                (click)="discountCode='';invalidDiscount=false;useDiscount=false">ادامه بدون
                کد تخفیف</button>
            </div>
          </div>

        </ng-container>
      </div>
      <div>
        <div
          class="kp-card m-1 mt-2 p-0 overflow-hidden border {{package.Best || vanguardPackages.length==1 ? 'border-2 border-vanguard vanguard-bg' : 'border-dark-gray'}}"
          *ngFor="let package of vanguardPackages">
          <div class="text-center f-white pb-1" *ngIf="package.Best || vanguardPackages.length==1">
            <i class="fa fa-star fs-xl ml-2"></i>
            <span *ngIf="vanguardPackages.length>1">به صرفه‌ترین بسته</span>
            <span *ngIf="vanguardPackages.length==1">خرید بسته</span>
          </div>
          <div class="p-2 {{package.Css||'white-bg'}}">
            <div class="d-flex justify-content-between mb-1">
              <div class="flex-grow-1 border-left">
                <span class="fw-bold">{{package.Title}}</span>
                <div class="fs-sm" *ngFor="let bonus of package.Bonus">
                  <i class="fa fa-check ml-1 f-green"></i>
                  {{bonus}}
                </div>
              </div>
              <div class="pr-2 text-center">
                <del class="f-gray" *ngIf="package._OriginalPrice || package.UIPrice">
                  {{package.UIPrice || package._OriginalPrice | number}} تومان
                </del>
                <div class="f-green">
                  <span class="fw-bold fs-lg">{{package.Price | number}}</span> تومان
                  <div class="fs-sm fw-bold f-green" *ngIf="package._Percent">({{package._Percent|percent}} تخفیف)
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-1">
              <button class="btn w-100" [class.btn-primary]="package.Best || vanguardPackages.length==1"
                [class.btn-secondary]="!package.Best && vanguardPackages.length!=1"
                (click)="openPaymentModal(package.Id)">
                انتخاب بسته
              </button>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!user?.Seeker?.PromoteUntilDays" class="py-0 btn btn-link f-blue pointer fs-sm"
        (click)="informationModal.open()">شک دارم! هنوز
        نمی‌دونم این سرویس چیه!؟</div>
      <div class="mt-3" *ngIf="!minimal">
        <app-enamad [licence]="false" [enamad]="true"></app-enamad>
      </div>

    </ng-container>

  </ng-container>

  <app-payment-check #paymentCheck (closed)="load()" (loaded)="onCheckPayment($event)">
    <div successTemplate>
      <p>بسته کارجوی پیشتاز شما تا تاریخ {{user?.Seeker?.PromoteUntil | pdate:'[yy]/[mm]/[dd]'}} فعال شد.</p>
      <!-- <div *ngIf="!user?.Seeker.IsAcceptable" class="btn btn-yellow w-100" routerLink="/seeker/wizard">
        خوب! بریم برای تکمیل رزومه‌مون
      </div>
      <div *ngIf="user?.Seeker.IsAcceptable" class="btn btn-yellow w-100" routerLink="/seeker/profile"
        [queryParams]="{tab:'resume'}">
        خوب! بریم برای تکمیل رزومه‌مون
      </div> -->
    </div>
    <ng-template #reasonInformation>
      <ng-template [ngTemplateOutlet]="reasonInformationTemplate"></ng-template>
    </ng-template>
    <ng-template #reasonExpensive>
      <ng-template [ngTemplateOutlet]="reasonExpensiveTemplate"></ng-template>
    </ng-template>
  </app-payment-check>

</div>

<ngx-smart-modal #paymentModal identifier="paymentModal">
  <ngx-spinner name="payment" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="d-flex flex-column container-capped-sm f-initial text-right py-2">
    <div class="border-bottom mb-3">
      <!-- <div class="text-center green-bg f-white fw-bold fs-lg">پرداخت شما ضمانت بازگشت وجه دارد!</div> -->
      <h5 class="kp-title-line mb-2">
        یک روش رو از زیر انتخاب کن
      </h5>
    </div>
    <div class="mb-2 pb-2 border-bottom pointer" (click)="pay()">
      <div class="h6">پرداخت از طریق درگاه اینترنتی</div>
      <div class="f-gray">توجه: نیاز به رمز دوم یا رمز پویا دارد.</div>
      <div class="text-left ">
        <button class="btn btn-primary my-2 flex-column">پرداخت آنلاین </button>
      </div>
    </div>
    <div class="mb-2 pb-2 pointer" (click)="manualModal.open()">
      <div class="h6">پرداخت از طریق کارت به کارت</div>
      <div class="f-gray">از طریق <b>دستگاه خودپرداز(ATM)</b> یا نرم‌افزارهای انتفال وجه مانند
        <b>آپ و همراه کارت و ...</b>
      </div>
      <div class="text-left ">
        <button class="btn btn-primary my-2 flex-column">پرداخت کارت به کارت </button>
      </div>
    </div>
  </div>
</ngx-smart-modal>

<ngx-smart-modal #informationModal identifier="informationModal">
  <ng-template [ngTemplateOutlet]="reasonInformationTemplate"></ng-template>
</ngx-smart-modal>

<ng-template #reasonInformationTemplate>
  <div class="container-capped text-justify p-2">
    <h3>خوب! کارجوی پیشتاز کیست؟</h3>
    <div>همین الان که داری این مطلب رو می‌خونی، {{totalJob|number}} فرصت شغلی در کارپیشه وجود داره.</div>
    <div>طبق داده‌های ما، هر آگهی استخدام میانگین در حدود 10 روز فعال‌ه. پس هر ماه حدود
      <span class="fw-bold f-white green-bg px-1">{{Math.floor(totalJob*3/1000)*1000|number}} فرصت شغلی</span> وارد
      کارپیشه و چند روز بعد هم ازش خارج می‌شه.
    </div>
    <div>شما می‌تونی از جستجوی دقیق‌ و رایگان کارپیشه استفاده و شغل مورد علاقه‌ی خودت رو پیدا کنی،</div>
    <div class="col-12 text-center">
      <div class="abs-fill d-flex align-items-center">
        <div class="border-top border-dark-gray border-2 w-100"></div>
      </div>
      <h4 class="white-bg d-inline-block z-1 px-2 h4">و یا</h4>
    </div>
    <div>فقط یه بار توانایی‌ها و علایق خودت رو به ما بگی!</div>
    <div>بعد، هر روزه هفته صبح و شب، کاملا حواسمون به همه‌ی این آگهی‌ها هست.
      <span class="fw-bold f-green">دونه به دونه شون!</span>
      و به محض اینکه موردی مورد پسندت پیدا شد سریع بهت اطلاع می‌دیم.
      <br />و در آخر! بانک داده‌مون نشون داده
      <span class="fw-bold f-white red-bg px-1">کارفرماها خیلی عجول‌ن!</span>
      یعنی بعد از یکی دو روز تصمیمشون رو می‌گیرن.
    </div>
    <h5 class="vanguard-bg f-white rounded-xl p-1">کارجوی پیشتاز، اون کارجویی‌ه که توی همین یکی دو روز اول با
      کارفرماش
      آشنا شده باشه</h5>
    <div class="text-left py-2">
      <button class="btn btn-primary" (click)="paymentCheck.retry();informationModal.close()">حالا فهمیدم چی شد! بریم
        برای پرداخت</button>
    </div>
  </div>
</ng-template>

<ng-template #reasonExpensiveTemplate>
  <div class="container-capped text-justify p-1" *ngIf="payment">
    <h3>چرا {{payment.Amount|number}} تومن؟</h3>
    <div>همین الان که داری این مطلب رو می‌خونی، {{totalJob|number}} فرصت شغلی در کارپیشه وجود داره.</div>
    <div>طبق داده‌های ما، هر آگهی استخدام میانگین در حدود 10 روز فعال‌ه. پس هر ماه حدود
      <span class="fw-bold f-white green-bg px-1">{{Math.floor(totalJob*3/1000)*1000|number}} فرصت شغلی</span> وارد
      کارپیشه و چند روز بعد هم ازش خارج می‌شه.
    </div>
    <div>شما می‌تونی از جستجوی دقیق‌ و رایگان کارپیشه استفاده و شغل مورد علاقه‌ی خودت رو پیدا کنی،</div>
    <div class="col-12 text-center">
      <div class="abs-fill d-flex align-items-center">
        <div class="border-top border-dark-gray border-2 w-100"></div>
      </div>
      <h4 class="white-bg d-inline-block z-1 px-2 h4">و یا</h4>
    </div>
    <div>فقط یه بار توانایی‌ها و علایق خودت رو به ما بگی!</div>
    <div>بعد، هر روزه هفته صبح و شب، کاملا حواسمون به همه‌ی این آگهی‌ها هست.
      <span class="fw-bold f-green">دونه به دونه شون!</span>
      و به محض اینکه موردی مورد پسندت پیدا شد سریع بهت اطلاع می‌دیم.
      <br />و در آخر! بانک داده‌مون نشون داده
      <span class="fw-bold f-white red-bg px-1">کارفرماها خیلی عجول‌ن!</span>
      یعنی بعد از یکی دو روز تصمیمشون رو می‌گیرن.
    </div>
    <h5 class="vanguard-bg f-white rounded-xl p-1">شما با پرداخت فقط
      <span *ngIf="payment.Item.month">روزی {{Math.floor(payment.Amount/(payment.Item.month*30))|number}}</span>
      <span *ngIf="!payment.Item.month">{{payment.Amount|number}}</span>
      تومن، اون کارجویی‌ میشی که توی همین یکی دو روز اول با کارفرماش آشنا می‌شه
    </h5>
    <div class="text-left py-2">
      <button class="btn btn-primary" (click)="paymentCheck.retry()">حالا فهمیدم چی شد! بریم
        برای پرداخت</button>
    </div>
  </div>
</ng-template>

<app-manual-payment-modal #manualModal [amount]="toPay" (submitPayment)="pay($event)"></app-manual-payment-modal>